export default __webpack_public_path__ + "images/4c7ab92759b13998ff03ab70e5520654-bullies.svg";